import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { catchError, Observable, switchMap, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import jwt_decode from 'jwt-decode';
import { B2cService } from './b2c.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  b2cAccessToken!: string;

  constructor(private b2cService: B2cService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return this.b2cService.getAccessToken().pipe(
      tap((token) => {
        this.b2cService.newAccessToken = token;
      }),
      switchMap((token) => {
        let authRequest = request;
        var decoded: any = jwt_decode(
          request.headers.get('Authorization')!.substring(6)
        );
        authRequest = request.clone({
          setHeaders: {
            'Ocp-Apim-Subscription-Key': environment.ocpApimSubscriptionValue,
            'IP-Address': decoded.ipaddr,
            idToken: sessionStorage.getItem('idToken') || 'unknown',
            Region: localStorage.getItem('region') || 'unknown',
            b2cAccessToken: 'Bearer ' + token.access_token,
          },
        });

        return next.handle(authRequest);
      }),
      catchError((error: any) => {
        console.log(error);
        let authRequest = request;
        var decoded: any = jwt_decode(
          request.headers.get('Authorization')!.substring(6)
        );
        authRequest = request.clone({
          setHeaders: {
            'Ocp-Apim-Subscription-Key': environment.ocpApimSubscriptionValue,
            'IP-Address': decoded.ipaddr,
            idToken: sessionStorage.getItem('idToken') || 'unknown',
            Region: localStorage.getItem('region') || 'unknown',
            b2cAccessToken: 'unknown',
          },
        });
        return next.handle(authRequest);
      })
    );
  }
}
